import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { AlertTriangle, Folder } from 'lucide-react';
import { Checkbox } from '../../ui/checkbox';
import { ICONE } from './CartellaVista';

const Avvisi = ({ c }) => (
  <>
    {c.documenti + c.registri === 0 && <span className="block text-[11px] text-slate-500">Vuota: l'ispettore non la vede finché non carichi un documento</span>}
    {c.scaduti > 0 && <span className="block text-[11px] font-semibold text-rose-700">{c.scaduti} scadut{c.scaduti === 1 ? 'o' : 'i'} da rinnovare (l'ispettore non vede avvisi né scadenze)</span>}
    {c.mancano.length > 0 && (
      <span className="block text-[11px] text-amber-700">Manca: {c.mancano.slice(0, 2).join(', ')}{c.mancano.length > 2 ? ` e altri ${c.mancano.length - 2}` : ''}</span>
    )}
  </>
);

const Riga = ({ c, attiva, onCambia, profilo }) => {
  const Icona = ICONE[c.icona] || Folder;
  return (
    <label data-testid={`owner-folder-row-${profilo}-${c.codice}`}
      className={`flex items-start gap-3 p-3 rounded-xl border cursor-pointer transition-colors ${attiva ? 'border-slate-300 bg-white hover:border-slate-900' : 'border-dashed border-slate-200 bg-slate-50 hover:border-slate-400'}`}>
      <Checkbox checked={attiva} onCheckedChange={() => onCambia(c.codice)} data-testid={`owner-folder-checkbox-${profilo}-${c.codice}`} className="mt-2.5" />
      <span className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${attiva ? 'bg-slate-900 text-white' : 'bg-slate-200 text-slate-500'}`}><Icona className="h-4 w-4" /></span>
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-semibold text-slate-900">{c.nome}</span>
        <span className="block font-mono text-[10px] uppercase tracking-wider text-slate-500">{c.documenti} documenti · {c.registri} registri</span>
        <Avvisi c={c} />
      </span>
    </label>
  );
};

export const CartelleProfilo = ({ profilo, cartelle, onSalva }) => {
  const [scelte, setScelte] = useState(profilo.cartelle);
  useEffect(() => setScelte(profilo.cartelle), [profilo]);

  const cambia = (codice) => {
    const nuove = scelte.includes(codice) ? scelte.filter((x) => x !== codice) : [...scelte, codice];
    if (!nuove.length) { toast.error('Lascia almeno una cartella'); return; }
    setScelte(nuove);
    onSalva(nuove);
  };
  const incluse = cartelle.filter((c) => scelte.includes(c.codice));
  const altre = cartelle.filter((c) => !scelte.includes(c.codice));
  const niente = incluse.every((c) => c.documenti + c.registri === 0);

  return (
    <section className="bg-white rounded-2xl border border-slate-200 p-4 lg:p-5 space-y-4" data-testid="owner-folders">
      <div>
        <h4 className="font-bold text-slate-900">Cartelle che vede l'ispettore</h4>
        <p className="text-sm text-slate-600">Già pronte per questo tipo di controllo. Togli o aggiungi una cartella con la spunta: vale subito, anche sul QR già stampato.</p>
      </div>
      {niente && (
        <p className="flex items-start gap-2 text-sm font-semibold text-rose-800 bg-rose-50 border border-rose-200 rounded-xl p-3" data-testid="owner-folders-empty-warning">
          <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />Ora questo ispettore non vede nessun documento: caricali in HACCP → Documenti oppure aggiungi una cartella qui sotto.
        </p>
      )}
      <div className="grid gap-2 lg:grid-cols-2" data-testid="owner-folders-included">
        {incluse.map((c) => <Riga key={c.codice} c={c} attiva onCambia={cambia} profilo={profilo.codice} />)}
      </div>
      {altre.length > 0 && (
        <div className="space-y-2">
          <p className="font-mono text-[11px] uppercase tracking-wider text-slate-500">Puoi aggiungere</p>
          <div className="grid gap-2 lg:grid-cols-2" data-testid="owner-folders-other">
            {altre.map((c) => <Riga key={c.codice} c={c} attiva={false} onCambia={cambia} profilo={profilo.codice} />)}
          </div>
        </div>
      )}
    </section>
  );
};
